export default __webpack_public_path__ + "static/media/workoutFasting.e499fe05.svg";